import { PayPalScriptProvider } from "@paypal/react-paypal-js";

/**
 * PayPalProvider — page-level wrapper so each page can choose subscription vs one-time.
 * The two modes require different SDK query params and are mutually exclusive.
 *
 * Usage:
 *   <PayPalProvider mode="capture">  {/* Deposit, OneOff *_/}
 *   <PayPalProvider mode="subscription"> {/* Retainer, Pricing *_/}
 */
export default function PayPalProvider({ mode = "capture", children }) {
  const clientId = process.env.REACT_APP_PAYPAL_CLIENT_ID;
  if (!clientId) return children;

  const options =
    mode === "subscription"
      ? {
          "client-id": clientId,
          currency: "USD",
          intent: "subscription",
          vault: true,
          components: "buttons",
        }
      : {
          "client-id": clientId,
          currency: "USD",
          intent: "capture",
          components: "buttons",
        };

  return <PayPalScriptProvider options={options}>{children}</PayPalScriptProvider>;
}
